export default {
  "content": "<path d=\"M398.57 80H113.43v16S87.51 272 256 272 398.57 96 398.57 96zM256 272v160M352 432H160M112 160h288\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};